import { useEffect } from 'react'
import { BaseModal } from './_BaseModal'
import { Button } from 'components/atoms/buttons/Button'
import swal from 'sweetalert2'
import { updateUser } from 'api/user/updateUser'
import { FormProvider, useForm } from 'react-hook-form'
import { InputText } from 'components/atoms/inputs/InputText'
import { deleteUser } from 'api/user/deleteUser'
import { AuthoritySelector } from 'components/atoms/selects/AuthoritySelector'
import { UserDataType } from 'api/user/useAllUser'

type Props = {
  userData: UserDataType
  onClose: () => void
  updateUserList: () => void
}
export const UpdateUserModal = (props: Props): JSX.Element | null => {
  const { userData, onClose, updateUserList } = props
  type FormValue = {
    userId: string
    userCode: string
    email: string
    name: string
    authorityCode: 'GENERAL' | 'ADMIN'
    version: string
  }
  const methods = useForm<FormValue>({
    defaultValues: {}
    // resolver: zodResolver(CompanyCreateSchema)
  })
  useEffect(() => {
    methods.reset({
      userId: userData.id,
      userCode: userData.code,
      email: userData.email,
      name: userData.lastName + ' ' + userData.firstName,
      authorityCode: userData.authorityCode,
      version: userData.version
    })
  }, [userData, methods])

  const userUpdateHandler = async (data: any) => {
    if (userData) {
      const requestParams = {
        userId: data.userId,
        authorityCode: data.authorityCode,
        version: data.version
      }
      await updateUser(requestParams)
        .then(() => {
          swal
            .fire({
              icon: 'info',
              text: 'ユーザー情報を更新しました。',
              confirmButtonText: 'OK'
            })
            .then((result) => {
              if (result.isConfirmed) {
                updateUserList()
                onClose()
              } else {
                return
              }
            })
        })
        .catch((error: any) => {
          swal.fire({
            icon: 'error',
            text: error?.data?.message || 'ユーザー情報の更新に失敗しました。',
            confirmButtonText: 'OK'
          })
        })
    }
  }
  const userDeleteHandler = async () => {
    const requestParams = { userId: userData.id }
    swal
      .fire({
        icon: 'info',
        text: 'ユーザーを削除しますか？',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        showCancelButton: true
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteUser(requestParams)
            .then(() => {
              swal
                .fire({
                  icon: 'info',
                  text: 'ユーザーを削除しました。',
                  confirmButtonText: 'OK'
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    onClose()
                  } else {
                    return
                  }
                })
            })
            .catch((error: any) => {
              swal.fire({
                icon: 'error',
                text: error?.data?.message || 'ユーザーの削除に失敗しました。',
                confirmButtonText: 'OK'
              })
            })
        }
      })
  }
  return (
    <BaseModal style={`w-[400px]`}>
      <FormProvider {...methods}>
        <div className={'mb-2 flex'}>
          <span className={'text-gray-600'}>{'ユーザー情報更新'}</span>
        </div>
        <form onSubmit={methods.handleSubmit(userUpdateHandler)}>
          <InputText name={'userCode'} label={'ユーザーID'} disabled />
          <InputText name={'name'} label={'名前'} disabled />
          <InputText name={'email'} label={'メールアドレス'} disabled />
          <AuthoritySelector name={'authorityCode'} />
          <div className="mt-4 space-y-4">
            <div className={'flex justify-between'}>
              <div className={'w-20'}>
                <Button
                  type={'button'}
                  label={'削除'}
                  clickHandler={userDeleteHandler}
                />
              </div>
              <div className={'flex space-x-2'}>
                <div className={'w-20'}>
                  <Button label={'更新'} />
                </div>
                <div className={'w-20'}>
                  <Button
                    type={'button'}
                    label={'閉じる'}
                    clickHandler={onClose}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </BaseModal>
  )
}
